export const getSelectedOptionsTotal = (options: unknown[]) => {
    return `${options.length.toString()} selected`;
}